import React, { Component } from "react"
import PropTypes from "prop-types"
import { RadioButton, RadioButtonGroup } from "material-ui/RadioButton"
import { blue500, greenA200 } from "material-ui/styles/colors"

import IconButton from "material-ui/IconButton"
import FormatIconLeft from "material-ui/svg-icons/editor/format-align-left"
import FormatIconCenter from "material-ui/svg-icons/editor/format-align-center"
import FormatIconRight from "material-ui/svg-icons/editor/format-align-right"

import Paper from "material-ui/Paper"
import { Card, CardHeader, CardText } from "material-ui/Card"
import ActionSave from "material-ui/svg-icons/content/save"
import ActionCopy from "material-ui/svg-icons/content/content-copy"
import ActionPaste from "material-ui/svg-icons/content/content-paste"
import Slider from "material-ui/Slider"
import SelectField from "material-ui/SelectField"
import MenuItem from "material-ui/MenuItem"
import { DivHeaderActions, DivTitle } from "./styled"
import { SketchColorPicker } from "../../../components"
import { Counter, BlockCounter } from "./components"

class DividerView extends Component {
  constructor(props) {
    super(props)
    const {
      line,
      lineColor,
      containerPadding,
      width,
      alignValue,
      size,
    } = props.data.values
    const widthValue = width.split("%").join("") * 1
    const sizeValue = size.split("px").join("") * 1
    this.state = {
      isEditMode: false,
      expanded: true,
      lineColor: lineColor,
      width: widthValue,
      line: line,
      alignValue: alignValue,
      containerPadding: containerPadding,
      size: sizeValue,
    }
  }
  handleExpandChange = (expanded) => {
    this.setState({ expanded: expanded })
  }
  onClickSave = () => {
    let newData = this.props.data
    newData.values.lineColor = this.state.lineColor
    newData.values.line = this.state.line
    newData.values.alignValue = this.state.alignValue
    newData.values.containerPadding = this.state.containerPadding
    newData.values.width = this.state.width + "%"
    newData.values.size = this.state.size + "px"
    this.props.onUpdateData(newData)
  }
  onUpdateColor = (color) => {
    this.setState({ lineColor: color })
  }
  onUpdatePadding = (padding) => {
    this.setState({ containerPadding: padding })
  }
  onUpdateWidth = (event, value) => {
    this.setState({ width: value })
  }
  onChangeAlign = (value) => {
    this.setState({ alignValue: value })
  }
  onUpdateLineSize = (value) => {
    this.setState({ size: value })
  }
  onChangeLine = (event, index, value) => this.setState({ line: value })
  onClickCopy = () => {
    let newData = this.props.data
    newData.values.lineColor = this.state.lineColor
    newData.values.line = this.state.line
    newData.values.alignValue = this.state.alignValue
    newData.values.containerPadding = this.state.containerPadding
    newData.values.width = this.state.width + "%"
    newData.values.size = this.state.size + "px"
    localStorage.setItem("DividerView", JSON.stringify(newData.values))
  }
  onClickPaste = () => {
    const dividerContent = JSON.parse(localStorage.getItem("DividerView"))
    if (dividerContent) {
      const {
        line,
        lineColor,
        containerPadding,
        width,
        alignValue,
        size,
      } = dividerContent
      const widthValue = width.split("%").join("") * 1
      const sizeValue = size.split("px").join("") * 1
      this.setState({
        lineColor: lineColor,
        width: widthValue,
        line: line,
        alignValue: alignValue,
        containerPadding: containerPadding,
        size: sizeValue,
      })
    }
  }

  render() {
    return (
      <div style={{ width: "100%" }}>
        <div style={styles.paperCard}>
          <Card
            expanded={this.state.expanded}
            onExpandChange={this.handleExpandChange}
          >
            <CardHeader
              title="General"
              subtitle="Content Divider"
              actAsExpander={true}
              showExpandableButton={true}
              style={styles.headerCard}
            />
            <CardText
              expandable={true}
              style={{ overflowY: "scroll", height: 500 }}
            >
              <Paper style={styles.paperText} zDepth={1}>
                <DivTitle>Alignment</DivTitle>
                <RadioButtonGroup
                  name="alignment"
                  valueSelected={this.state.alignValue}
                  onChange={this.onChangeAlign}
                  style={styles.radioGroup}
                >
                  <RadioButton
                    value="left"
                    label=""
                    checkedIcon={<FormatIconLeft style={{ color: blue500 }} />}
                    uncheckedIcon={
                      <FormatIconLeft style={{ color: greenA200 }} />
                    }
                    style={styles.radioButton}
                  />
                  <RadioButton
                    value="center"
                    label=""
                    checkedIcon={
                      <FormatIconCenter style={{ color: blue500 }} />
                    }
                    uncheckedIcon={
                      <FormatIconCenter style={{ color: greenA200 }} />
                    }
                    style={styles.radioButton}
                  />
                  <RadioButton
                    value="right"
                    label=""
                    checkedIcon={<FormatIconRight style={{ color: blue500 }} />}
                    uncheckedIcon={
                      <FormatIconRight style={{ color: greenA200 }} />
                    }
                    style={styles.radioButton}
                  />
                </RadioButtonGroup>
              </Paper>
              <Paper style={styles.paperText} zDepth={1}>
                <SketchColorPicker
                  title={"Line Color"}
                  onUpdateColor={(color) => this.onUpdateColor(color)}
                  color={this.state.lineColor}
                />
              </Paper>
              <Paper style={styles.paperText} zDepth={1}>
                <DivTitle>Line Type</DivTitle>
                <SelectField
                  floatingLabelText=""
                  value={this.state.line}
                  onChange={this.onChangeLine}
                >
                  <MenuItem value="solid" primaryText="Solid" />
                  <MenuItem value="dotted" primaryText="Dotted" />
                  <MenuItem value="dashed" primaryText="Dashed" />
                </SelectField>
              </Paper>
              <Paper style={styles.paperText} zDepth={1}>
                <DivTitle>Line Size</DivTitle>
                <Counter
                  onSetValue={(value) => this.onUpdateLineSize(value)}
                  value={this.state.size}
                  interval={1}
                  subtitle="px"
                />
              </Paper>
              <Paper style={styles.paperText} zDepth={1}>
                <DivTitle>Width {this.state.width} %</DivTitle>
                <Slider
                  min={0}
                  max={100}
                  step={1}
                  value={this.state.width}
                  onChange={this.onUpdateWidth}
                />
              </Paper>
              <Paper style={styles.paperText} zDepth={1}>
                <DivTitle>Container Padding</DivTitle>
                <BlockCounter
                  containerPadding={this.state.containerPadding}
                  onUpdatePadding={(containerPadding) =>
                    this.onUpdatePadding(containerPadding)
                  }
                />
              </Paper>
            </CardText>
          </Card>
        </div>
        <DivHeaderActions>
          <IconButton
            onClick={this.onClickCopy}
            iconStyle={{ color: "#FFFFFF" }}
          >
            <ActionCopy />
          </IconButton>
          <IconButton
            onClick={this.onClickPaste}
            iconStyle={{ color: "#FFFFFF" }}
          >
            <ActionPaste />
          </IconButton>
          <IconButton
            onClick={this.onClickSave}
            iconStyle={{ color: "#FFFFFF" }}
          >
            <ActionSave />
          </IconButton>
        </DivHeaderActions>
      </div>
    )
  }
}

const styles = {
  paper: {
    margin: 10,
    padding: 10,
  },
  headerCard: {
    display: "flex",
    textAlign: "left",
  },
  paperCard: {
    margin: 10,
  },
  paperText: {
    padding: 10,
    marginBottom: 10,
  },
  customWidth: {
    width: 150,
  },
  block: {
    maxWidth: 250,
  },
  radioButton: {
    width: 60,
  },
  radioGroup: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "flex-start",
    flex: "1 auto",
  },
}

DividerView.propTypes = {
  data: PropTypes.object,
  onUpdateData: PropTypes.func.isRequired,
}

DividerView.defaultProps = {
  data: {},
}
export default DividerView



// WEBPACK FOOTER //
// ./src/editor/layout/addons/props/DividerView.js